import { createSignal } from "solid-js";

export type Theme = "light" | "dark";

const [theme, setThemeSignal] = createSignal<Theme>("light");

export const themeStore = {
  theme,
};

export const themeActions = {
  setTheme: (newTheme: Theme) => {
    setThemeSignal(newTheme);
  },
  toggleTheme: () => {
    setThemeSignal((prev) => (prev === "light" ? "dark" : "light"));
  },
};
